/** @jsxImportSource @emotion/react */
import React from 'react';
import type { UListProps } from 'shared/types/html-attributes';
import { getCollapsibleAnimationStyles } from 'shared/utils';
import CircleIcon from 'ud-ui/components/icon/circle-icon';
import AllTournamentButton from '../all-tournament-button';
import { MenuSkeletonBlock } from '../../styles';
import * as S from './styles';

interface ITournamentDropdownMenuProps extends UListProps {
  isOpen: boolean;
  loading?: boolean;
  recentlyAdded: {
    link: string;
    checkPath: string;
    label: string;
  }[];
}

function TournamentDropdownMenu(props: ITournamentDropdownMenuProps) {
  const { recentlyAdded, isOpen, loading, ...rest } = props;

  if (loading) {
    return (
      <S.AppUL style={{ ...getCollapsibleAnimationStyles(isOpen, '166px'), ...rest.style }} {...rest}>
        <div className="flex w-full flex-col">
          {Array.from({ length: 5 }, (_, index) => (
            <li key={index}>
              <MenuSkeletonBlock key={index} className="skeleton-block" />
            </li>
          ))}
          <AllTournamentButton disabled />
        </div>
      </S.AppUL>
    );
  }

  return (
    <S.AppUL style={{ ...getCollapsibleAnimationStyles(isOpen, '166px'), ...rest.style }} {...rest}>
      <div className={'flex flex-col'}>
        {recentlyAdded?.map((play) => (
          <li key={play.link}>
            <S.TournamentItem
              to={play.link}
              checkPath={play.checkPath}
              type="subhead"
              className={'tip'}
              title={play.label}
              variant="secondary"
            >
              <div className={'flex items-center gap-2'}>
                <CircleIcon />
                <S.TournamentLabel>{play.label}</S.TournamentLabel>
              </div>
            </S.TournamentItem>
          </li>
        ))}
        <AllTournamentButton variant="primary" />
      </div>
    </S.AppUL>
  );
}

export default TournamentDropdownMenu;
